$(document).on('ready', function(){
$('#addToCart').on("click", function(){

  $('.shapp_option_set select').each( function(){
    if( $(this).val() == "Please Make A Selection" ){
      $('#addToCart').prop('disabled',true);
      $(this).css({border: '1px solid #c12424'});
    } 
  });
  
});


$('.shapp_option_set select').on('change', function(){
  if( $(this).val() != "Please Make A Selection" ){
    $('#addToCart').prop('disabled',true);
    $(this).css({border: 'none'});
  }
  $('.shapp_option_set select').each( function(){
    if( $(this).val() == "Please Make A Selection" ){
      $('#addToCart').prop('disabled',true);
      $(this).css({border: '1px solid #c12424'});
    } else {
      $('#addToCart').prop('disabled',false);
    }
  });
});
});